/* eslint-disable */
import $ from "jquery";
import React from "react";
import { Col, Icon, Modal, Preloader, ProgressBar, Row, SideNav, SideNavItem } from "react-materialize";
import Notifications, { notify } from "react-notify-toast";
import { Link, withRouter } from "react-router-dom";
import store from "store";
import "../styles/app.css";
import { trans } from "./Lang";
import Main from "./Main";
import * as rdd from 'react-device-detect';
import { API_CATEGORY, API_PROVINCE, BASE_URL, CheckAuth, API_CEK_USER_DETAIL } from "./Util";


class App extends React.Component {
	// static CONTACT_PHONE = "0811 9309 114";
	// static CONTACT_EMAIL = "campus.hq@geti.id";
	// static FB_URL = "https://www.facebook.com/GeTi.Incubator/";
	// static IG_URL = "https://www.instagram.com/geti.incubator/?hl=en";
	// WEBSITE = "anugerahcinta.org";
	// static LPK_NAME = "GeTi";
	// static WA_URL = "https://wa.me/08119309114";
	// static EMAIL_URL = "campus.hq@geti.id";
	static CONTACT_PHONE = "08111377915";
	static CONTACT_EMAIL = "admin@kerjalestari.id";
	static FB_URL = "https://www.facebook.com/";
	static IG_URL = "https://www.instagram.com/";
	static WEBSITE = "anugerahcinta.org";
	static LPK_NAME = "Kerjalestari";
	static WA_URL = "https://wa.me/+628111377915";
	static EMAIL_URL = "mailto:admin@kerjalestari.id";

	constructor(props) {
		super(props);
		store.remove("home_data");

		this.state = {
			loading: false,
			loadingCategory: true,
			categories: [],
			os: null,
			search_url: "/course/catalog",
			is_completed: true,
			ticket_counter: 0
		};

		window.onpopstate = function(e) {
			if ($(".modal-overlay").length > 0) {
				$(".modal-overlay").click();
				props.history.go(1);
			}
		};

		this.socmedClick = this.socmedClick.bind(this);

		$(".btn-help").css({
			position: "fixed",
			bottom: "0rem",
			right: "0rem"
		});
	}

	componentDidMount() {
		if (!this.state.categories.length) {
			this.handleLoadData();
		}
	}

	handleLoadData = e => {
		var categories = null;

		if (!categories) {
			$.getJSON(API_CATEGORY).then(data => {
				this.setState({ categories: data.payload, loadingCategory: false });

				if(CheckAuth()) {
					this.checkPersonalDataStatus();
				}
			});
		} else {
			this.setState({ categories: categories, loadingCategory: false });
		}

		var provinces = store.get("provinces");

		if (!provinces) {
			$.getJSON(API_PROVINCE).then(data => {
				store.set("provinces", data.payload);
			});
		}
	};

	checkPersonalDataStatus = () => {
		var data_is_completed = store.get("data_is_completed");

		if(!data_is_completed) {
			$.getJSON(API_CEK_USER_DETAIL).then(data => {
				this.setState({ is_completed: data.payload.status });

				store.set("data_is_completed", data.payload.status);
			});	
		}
	}

	toggleTopNotification = (saveState, e) => {
		$("#root").toggleClass("mt-65");
		if (saveState) {
			store.set("top-notification", true);
		}
	};

	handleSearchCourse = (target, e) => {
		e.preventDefault();
		let param = { query: $(target).val() };

		$(target).blur();

		this.props.history.push("/list-course?" + $.param(param));
	};

	socmedClick = e => {
		console.log(e.target);
	};

	notifyPersonalData = () => {
		return (
			<div className="notify-personal-data" onClick={() => this.props.history.push("/personal-data", {needRefresh: false})}>
				Harap lengkapi data pribadi kamu. Klik di sini untuk melengkapi.
			</div>
		)
	}

	render() {
		let counter = this.state.ticket_counter;

		return (
			<div>
				<ProgressBar className="fixed loading" style={{ display: "none" }} />

				{!this.state.is_completed && (this.notifyPersonalData())}

				<Notifications />

				<div className={ !this.state.is_completed ? 'navbar-fixed mt-m' : 'navbar-fixed' }>
					<nav className="shadowed">
						<div className={rdd.isMobile ? `nav-wrapper` :  'nav-large-screen'}>
							<Link to="/" className="brand-logo hide-on-med-and-down">
								<img
									src={BASE_URL + "/img1/white-label/logo/logo-white.png"}
								/>
							</Link>
							<a
								href="#"
								data-activates="mobile-demo"
								className="button-collapse"
							>
								<i className="material-icons">menu</i>
							</a>
							<form
								onSubmit={this.handleSearchCourse.bind(this, "#search_mobile")}
								className="hide-on-large-only"
							>
								<div className="input-field">
									<Link to="/" className="brand-logo">
										<img
											src={
												BASE_URL + "/img1/white-label/logo/logo-white.png"
											}
										/>
									</Link>
									<Link
										id="search_url"
										to="{this.state.search_url}"
										className="hide"
									/>
									<input
										placeholder={`Cari ${trans.course}`}
										id="search_mobile"
										type="search"
									/>
									<label className="label-icon" htmlFor="search">
										<i className="material-icons">search</i>
									</label>
								</div>
							</form>

							{CheckAuth() && (
								<ul
									className="right hide-on-med-and-down nav-menu"
									style={{ marginRight: "150px" }}
								>
									<li>
										<a href="/catalogue">
											<div style={{display:'flex', alignItems:'center'}}>
												<i className="material-icons left small icon-color">
													apps
												</i>
												<span>Katalog</span>
											</div>
										</a>
									</li>

									<li>
										<a href="/about-us" rel="noopener noreferrer">
										<div style={{display:'flex', alignItems:'center'}}>
											<i className="material-icons left small icon-color">
												info_outline
											</i>
											<span>Tentang Kami</span>
										</div>
										</a>
									</li>

									<li>
										<Link to="/faq">
										<div style={{display:'flex', alignItems:'center'}}>
											<i className="material-icons left small icon-color" >
												help_outline
											</i>
											<span>Bantuan</span>
										</div>
										</Link>
									</li>
								</ul>
							)}

							<SideNav
								trigger={
									CheckAuth() ? (
										<a
											className="right btn-menu font-orange ellipsis"
											style={{ minWidth: "150px" }}
										>
											{counter > 0 && (
												<div
													className="badge hide red center absolute-right"
													style={{ top: 0 }}
												>
													{counter}
												</div>
											)}
											<div>
												<img className="circle right" src={CheckAuth().foto} />
												<div className="hide-on-med-and-down" style={{display:'block', width:'100%'}}>
													<span>
														{" "}
														&nbsp; &nbsp; {CheckAuth().nama}{" "}
													</span>
												</div>
											</div>
										</a>
									) : (
										<a className="right btn-menu font-orange hide-on-large-only">
											<i className="material-icons">menu</i>
										</a>
									)
								}
								options={{
									closeOnClick: true,
									edge: "right",
									draggable: false
								}}
							>
								{CheckAuth() && (
									<span>
										<SideNavItem
											userView
											user={{
												image: CheckAuth().foto,
												name: CheckAuth().nama
											}}
										/>
										<SideNavItem divider />
										<li className="hide-on-large-only">
											<a href="/catalogue">
												Katalog
											</a>
										</li>
										<li className="hide-on-large-only">
											<a href="/about-us" rel="noopener noreferrer">
												Tentang Kami
											</a>
										</li>
										<li className="hide-on-large-only">
											<Link to="/faq">Bantuan</Link>
										</li>
										<li>
											<Link to="/personal-data">Profil Saya</Link>
										</li>
										<li>
											<Link to="/profile">Pelatihan Saya</Link>
										</li>
										<li>
											<Link to="/change-password">Ubah Password</Link>
										</li>
										
										<li>
											<Link to="/logout">Keluar</Link>
										</li>
									</span>
								)}

								{!CheckAuth() && (
									<span>
										<li>
											<a href="/catalogue">
												Katalog
											</a>
										</li>
										<li>
											<a href="/about-us" rel="noopener noreferrer">
												Tentang Kami
											</a>
										</li>
										<li>
											<Link to="/faq">Bantuan</Link>
										</li>
										<li>
											<Link to="/login">Masuk</Link>
										</li>
										<li>
											<Link to="/register">Daftar</Link>
										</li>
									</span>
								)}
							</SideNav>
							<div style={{ marginLeft: "130px" }}>

							<form
								style={{ width: "245px", position: "relative" }}
								onSubmit={this.handleSearchCourse.bind(this, "#search")}
								// onSubmit={this.handleSubmit}
								className="hide-on-med-and-down left form-bordered"
							>
								<div className="input-field" style={{ position: "relative" }}>
									<input
											style={{ width: '250px', paddingRight: '30px' }} // Add padding for close button space
											className="search"
											placeholder={`Cari ${trans.course}`}
											id="search"
											type="text"
											value={this.state.searchValue}
											onChange={this.handleInputChange}
									/>
									{this.state.searchValue && (
										<button
											type="button"
											onClick={this.clearInput}
											style={{
												position: "absolute",
												right: 0,
												top: "50%",
												transform: "translateY(-50%)",
												background: "transparent",
												border: "none",
												cursor: "pointer",
												fontSize: "2rem",
												color: "#aaa"
											}}
										>
											&times;
										</button>
									)}
								</div>
							</form>
								
							</div>

							{!CheckAuth() && (
								<ul className="right hide-on-med-and-down nav-menu">
								<li>
									<a href="/catalogue">
										<div style={{display:'flex', alignItems:'center'}}>
											<i className="material-icons left small icon-color">
												apps
											</i>
											<span>Katalog</span>
										</div>
									</a>
								</li>
								<li>
									<a href="/about-us" rel="noopener noreferrer">
										<div style={{display:'flex', alignItems:'center'}}>
											<i className="material-icons left small icon-color">
												info_outline
											</i>
											<span>Tentang Kami</span>
										</div>
									</a>
								</li>

									<li>
										<Link to="/faq">
											<div style={{display:'flex', alignItems:'center'}}>
												<i className="material-icons left small icon-color" >
													help_outline
												</i>
												<span>Bantuan</span>
											</div>
										</Link>
									</li>

									<li>
										<Link to="/login">
										<div style={{display:'flex', alignItems:'center'}}>
											<i className="material-icons left small icon-color" >
												lock_open
											</i>
											<span>Masuk</span>
										</div>
										</Link>
									</li>

									<li>
										<Link to="/register">
											<div style={{display:'flex', alignItems:'center'}}>
												<i className="material-icons left small icon-color" >
												how_to_reg
												</i>
												<span>Daftar</span>
											</div>
										</Link>
									</li>
								</ul>
							)}
						</div>
					</nav>
				</div>

				<Main counter={counter} />

				<footer className="page-footer example" style={{ backgroundColor: "#9cbf3f" }}>
					<div className="container">
						<div className="row">
							<Col
								l={2}
								m={12}
								className="font-grey center-s hide-on-med-and-down"
							>
								<div className="valign-wrapper">
									<img
										className="mr-s" style={{height:"95px"}}
										src={BASE_URL + "/img1/white-label/logo/logo-white.png"}
									/>
								</div>
							</Col>
							<Col s={12} m={10} l={10} className="footer-wrapper">
								<Col s={12} m={4} l={4}>
									<div className="footer-center-icon" style={{display:'flex', alignItems:'center'}}>
										<a
											onClick={this.socmedClick}
											href={App.WA_URL}
											target="_blank"
										>
											<img
												className="mr-s height-30"
												src={BASE_URL + "/img1/home/ic_whatsapp.png"}
												name="WHATSAPP"
											/>
											
										</a>
										<span>{App.CONTACT_PHONE}</span>
									</div>
									
									<div className="footer-center-icon" style={{display:'flex', alignItems:'center'}}>
										<a
											onClick={this.socmedClick}
											href={App.EMAIL_URL}
											target="_blank"
										>
											<img
												className="mr-s height-30"
												src={BASE_URL + "/img1/home/ic_email.png"}
												name="EMAIL"
											/>
										</a>
										<span>{App.CONTACT_EMAIL}</span>
									</div>
									
								</Col>
								<Col s={12} m={4} l={4}>
								<a href="/about-us" rel="noopener noreferrer">
									<h5>Tentang Kami</h5>
								</a>
									<h6 className="contact-text text-black strong"><span>
										<Link to="/faq">
											FAQ
										</Link></span>
									</h6>
									<h6 className="contact-text text-black strong"><span>
										<Link to="/privacy-policy">
											Privacy Policy
										</Link></span>
									</h6>
								</Col>
								<Col s={12} m={4} l={4}>
									<h5>Social Media</h5>
									<Row className="socmed-wrapper">
										<Col l={4}>
											<div className="d-flex justify-content-between">
												<a
													onClick={this.socmedClick}
													href={App.FB_URL}
													target="_blank"
												>
													<img
														className="mr-s height-30"
														src={BASE_URL + "/img1/home/ic_facebook.png"}
														name="FACEBOOK"
													/>
												</a>
												<a
													onClick={this.socmedClick}
													href={App.IG_URL}
													target="_blank"
												>
													<img
														className="height-30"
														src={BASE_URL + "/img1/home/ic_instagram.png"}
														name="INSTAGRAM"
													/>
												</a>
											</div>
										</Col>
									</Row>
								</Col>

							</Col>
							<Col s={12} className="center geti-copyright text-center text-black">
								<hr />
								<span>
									Copyright 2024 © {App.LPK_NAME}.
								</span>
							</Col>
						</div>
					</div>
				</footer>
			</div>
		);
	}
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js